const ValidationMessage = "This field is required."
const translationStyles1=window?.psh_configs?.selectedLanguage === "ar" || window?.psh_configs?.selectedLanguage === "ar-SA";
const ThemeJSON = {
    "column":{
        "Enable":"true",
        "ReadOnlyStyle":"false",
        "heightselect":"set"
    },
    "section":{
        // BackColor: "#0072C6",
        // Bordercolor: "#e4e4e4",
        // Bordersize: "1px",
        // CombinedFontWeight: "Regular",
        // FontStyle: "",
        InterColumnSpacing: "",
        InterRowSpacing: "",
        ReadOnlyRowSpacing: "",
        RemoveMargins: "false",
        // Label: "",
        // SectionBackColor:"",
        SectionTheme:"Select",
        // SectionBackground:"Color",
        // Overlay: "false",
        // OverlayColor: "D7D7D7",
        MobileVisible: "true", 
        TabsVisible: "true",
        Visible : "true",
        ReadOnlyStyle : "false",
        Enable:'true'
    },
    "frame":{
        // Label: "",
        SectionTheme:"Select",
        // BackColor: "#0072C6",
        // Bordercolor: "#e4e4e4",
        // Bordersize: "1px",
        // CombinedFontWeight: "Regular",
        // FontColor: "#000000",
        // FontFamily: "Open Sans",
        // FontSize: "14px",
        // FontStyle: "",
        // FontWeight: "100",
        InterColumnSpacing: "",
        InterRowSpacing: "",
        ReadOnlyRowSpacing: "",
        RemoveMargins: "false",
        // SectionBackColor:"",
        // SectionType:"",
        // SectionBackground:"Color",
        // Overlay: "false",
        // OverlayColor: "D7D7D7",
        MobileVisible: "true", 
        TabsVisible: "true",
        // // ControlStyle:"Style2",
        Visible : "true",
        Enable:'true'

    },
    'captcha':{
        Enable: "true",
        MobileVisible: "true", 
        TabsVisible: "true",
        ControlStyle:"Style2"
    },
    'button': {
        "CustomId": "",
        //ButtonType : "Primary",
        IconAlignment : "Left",
        icon:{},
        iconFile:"",
        iconName:"",
        ButtonHorizontalAlignment: "Center",
        ButtonVerticalAlignment: "Center",
        Visible : "true",
        Enable : "true",
        // FontSize : "12px",
        // FontWeight : "400",
        // FontFamily : "Open Sans",
        // BackgroundColor : "#0072C6",
        // BorderColor:"#3D6CE9",
        // FontColor : "#FFFFFF",
        // CornerRadius: "2px",
        // SpacingLeft : "",
        // SpacingRight : "",
        // SpacingTop : "",
        // SpacingBottom : "",
        Tooltip: "",
        ControlDescription : "",
        CustomControlID : "",
        MobileVisible: "true", 
        TabsVisible: "true",
    },
     'slider':{
        Visible:"true",
        Mandatory:"false",
        ValidationMessage,
        Enable:"true",
        // FontColorSlider:"#000000",
        MinimumValue :0,
        MaximumValue :100,
        DefaultValueSlider:0,
        SetBreakpoint:1,
        // FontFamily:"Open Sans",
        // FontSize:"12px",
        // FontWeight:"300",
        LabelAlignment:"left",
        // ActiveSliderBar:"#243ED0",
        // InActiveSliderBar:"#243ED0",
        MobileVisible: "true", 
		TabsVisible: "true",
     },
    'datepick':{
        //  BackColor: "#FFFFFF",
        // BorderColor: "#dfe3e9",
        // BorderWidth: "1px",
        // BorderRadius:"3px",
        CombinedFontWeight: "Regular",
        CustomId: "",
        DefaultValue: "",
        Enable: "true",
        // FontColor: "",
        // FontFamily: "Open Sans",
        // FontSize: "12px",
        // FontStyle: "",
        // FontWeight: "",
        Grouping: "1",
        // LabelBackgoundColor: "",
        // LabelFontColor: "",
        // LabelFontFamily: "Open Sans",
        // LabelFontSize: "12px",
        // LabelFontWeight: "",
        // LabelInputAlignment: "Top-Down",
        // LabelInputRatio: "",
        Mandatory: "false",
        MaxDate: "",
        MaxDateAsCurrent: "false",
        MergeSection: "1",
        MinDate: "",
        MinDateAsCurrent: "false",
        OpenPicker: "1",
        // PickerType: "1",
        ReadOnly: "false",
        ReadOnlyStyle: "N",
        SelectPicker: "",
        Summary: "",
        TextAlignment: "",
        Labels:"12",
        TimeZone: "false",
        ToolTip: "",
        ValidationMessage,
        Visible: "true",
        validateMandatoryDisable: "N",
        ControlDescription:"",
        AllowManualInput:"false",
        DummyData:"",
        // DateFormat: "",
        DateType: "",
        MobileVisible: "true", 
        TabsVisible: "true",
        // ControlStyle: "Style1"
    },
    'textarea':{
        Visible : "true",
        Enable: "true",
        Mandatory:"false",
        ValidationMessage,
        Labels:"12",
       // EnableMandatoryOnDisable: "false",
        // Editable :"true",
        // LabelFontSize:"",
        // LabelFontColor:"#000000",
        // LabelFontFamily:"Open Sans",
        //LabelFontWeight:"400",
        // ControlStyle:"Style1",
        // BackColor:"#FFFFFF",
        // FontColor:"#000000",
        // FontFamily:"Open Sans",
        // FontSize:"",
        //FontWeight:"300",
        // BorderColor:"#c4c4c4",
        // BorderWidth:"1px",
        // BorderRadius:"3px",
        // MaxCharacterLength:"200",
        MaxCharacterLength:"",
        DummyData:"",
        AllowPaste : "true",
        AllowSpecialChars:"true",
        AllowCopy : "true",
        Alphabets:"true",
        Numerals:"true",
        Spaces:"true",
        // LabelInputAlignment:"Top-Down",
        // TextAlignment: translationStyles1 ? "right" : "left",
        CharacterSet:"initial",
        MobileVisible: "true", 
		TabsVisible: "true"
    },
    'tab': {
        // ControlStyle :"Style1",
        // ActiveTabCornerRadius :"6px",
        Visible : "true",
        height: "35px",
        Enable : "true",
        ReadOnly : "false",
        ReadOnlyStyle : "false",
        // BorderColor :"#C4C4C4",
        // BorderWidth :"1px",
        // BorderRadius : "2px",
        // ActiveTabFontFamily : "Open Sans",
        // ActiveTabFontSize : "14px",
        // ActiveTabFontWeight : "Normal",
        // ActiveTabFontColor : "#0072c6",
        // ActiveTabBackColor : "#FFFFFF",
        // ActiveTabWidth : "139px",
        // ActiveTabBorderBottomStyle : "5px solid #0072c6",
        ActiveTabBorderTopStyle : "hidden",
        ActiveTabBorderLeftStyle : "hidden",
        ActiveTabBorderRightStyle : "hidden",
        // ActiveTabBorderRadius : "",
        // InActiveTabFontFamily : "Open Sans",
        // InActiveTabFontSize :"14px",
        // InActiveTabFontWeight : "Normal",
        // InActiveTabFontColor : "#606060",
        // InActiveTabBackColor : "#FFFFFF",
        InActiveTabBorderTopStyle : "hidden",
        InActiveTabBorderLeftStyle : "hidden",
        InActiveTabBorderRightStyle : "hidden",
        // InActiveTabWidth : "139px",
        // TabBackgroundColor : "#FFFFFF",
        TabLabelsJustified : "false",
        ShowBorder : "true",
        Linebreak: "true",
        ShowSaveButtons : "false",
        GetDataOnDemand : "false",
        FixTabHeader : "false",
        MobileVisible: "true", 
        TabsVisible: "true",
    },
    'sheet': {
        MobileVisible: "true", 
        TabsVisible: "true",
    },
    'paragraph': {
        "CustomId": "",
        Visible : "true",
        MobileVisible: "true", 
        TabsVisible: "true",
    },
    'iframe':{
        SourceURL:"",
        Label:"",
        Visible : "true",
        MobileVisible: "true", 
        TabsVisible: "true",
    },
    'textbox' : {
        // ControlStyle:"Style1",
        Visible : "true",
        Enable : "true",
        Placeholder :"",
        // TextAlignment: translationStyles1 ? "right" : "left",
        EnableMandatoryOnDisable: "false",
        // Editable :"true",
        AllowPaste : "true",
        AllowCopy : "true",
        Alphabets:"true",
        Numerals:"true",
        Spaces:"true",
        AllowSpecialChars:"true",
        ValidationMessage,
        MaskingValue:"Select",
        MaskingType:"",
        MaskingLength:"",
        MobileVisible: "true", 
        TabsVisible: "true",
        Labels:"12",
        // BorderColor:"#dfe3e9",
        // BorderWidth:"1pt",
        // BorderRadius:"3pt",
        // BackColor:"#FFFFFF",
        // FontColor:"#000000",
        // FontFamily:"Open Sans",
        // LabelBackgoundColor:"#ffffff",
       // LabelFontColor:"#000000",
        // LabelFontFamily:"Open Sans",
        // LabelFontSize:"12pt",
        // LabelFontWeight:"400",
        DummyData:""
    },
    'picklist' : {
        Visible : "true",
        Enable : "true",
        AllowTyping : "false",
        PopupText: "",
        // BorderColor:"#dfe3e9",
        // BorderWidth:"1px",
        // BorderRadius:"3px",
        // ControlStyle:"Style1",
        // BackColor:"#FFFFFF",
        // FontColor:"#000000",
        // FontFamily:"Open Sans",
        // FontSize:"12pt",
        // FontWeight:"300",
        ValidationMessage,
        Labels:"12",
        // LabelBackgoundColor:"#ffffff",
        // LabelFontColor:"#000000",
        // LabelFontFamily:"Open Sans",
        // LabelFontSize:"12pt",
        // LabelFontWeight:"400",
        MobileVisible: "true", 
        TabsVisible: "true",
        AllowMultipleSection:"false"
    },
    'tile':{
        "TileType":"Vertical",
        "Enable" : "true",
        "Visible":"true",
        "Mandatory":"false",
        "TileSelectionType":"Single Select",
        // "TileBackgroundColor":"#FFFFFF",
        "TileBorderColor":"#DFE3E9",
        "TileCornerRadius":"4px",
        "AddShadowToTiles":"false",
        "TitleFontFamily":"Open Sans",
        "TitleFontSize":"15px",
        "TitleFontWeight":"300",
        "TitleFontColor":"#000000",
        "TextAlignment":"Left",
        "DescriptionFontFamily":"Open Sans",
        "DescriptionFontSize":"13px",
        "DescriptionFontWeight":"300",
        "DescriptionFontColor":"#000000",
        "PointsFontFamily":"#000000",
        "PointsFontSize":"13px",
        "PointsFontWeight":"300",
        "PointsFontColor":"#000000",
        "PointsStyle":"bullet",
        "ButtonType" : "Secondary",
        "FontSize" : "12px",
        "FontFamily" : "Open Sans",
        // "BackgroundColor" : "#0072C6",
        // "FontColor" : "#0072C6",
        "CornerRadius": "2px",
        "LinkTextColor":"#0072C6",
        "Title":"true",
        "TileStyle":"Style1",
        "Image":"true",
        "Description":"true",
        "Points":"true",
        "Button":"true",
        "Link":"true",
        "ImageFitting":"Default",
        "MobileVisible": "true", 
        "TabsVisible": "true",
    },
    'checkbox':{
        "Visible" : "true",
        "Enable" : "true",
        //   "BackColor" : "#707070",
        // "ControlStyle":"Style2",
        //  "FontColor":"#000000",
        // "FontFamily":"Open Sans",
        // "FontSize":"12px",
        ValidationMessage,
        "Mandatory":"false",
        "BorderColor" : "#C4C4C4",
        //"ActiveStateColor" : "#707070",
        // "FontWeight":"300",
        "MobileVisible": "true", 
        "TabsVisible": "true",
    },
    'table' : {"BorderWidth":"", "CombinedFontWeight":"Bold", "CombinedHeaderFontWeight":"Bold","CustomId":"", "DuplicateRow":"true", "Enable":"true",
    "ControlStyle":"",
            //    "FontFamily":"", "FontStyle":"", 
            //    "FontWeight":"400", 
               "Grouping":"1", 
               "HeaderBackColor":"ffffff",  
               "TableScrollRadio": "defaultGridScroll",
               "HeaderFontFamily":"", 
               "HeaderFontSize":"", 
               'Height':"300",
               "AllowDownload" : "true",
               "AllowUpload" : "false",
               "HideAdd":"false", 
               "HideDelete":"false", "HidePrevNext":"N", "ListBtnAlignment":"0", "MergeSection":"1", "Searching":"true", "ShowCheckboxColumn":"false", "Sorting":"true", "Summary":"",
               "HideMoreOptions":"false",
               "Visible":"true", "isAdvancedListview":"false", "multiSelect":"true", "timeZone":"1","widthType" : "percentage", "ThemeLayout" : "box" ,
               "ShowCheckbox":"true",
               "AddRowButtonLabel":"true",
            //    "ListviewTitleFontFamily":"Open Sans",
            //    "ListviewTitleFontSize":"14px",
            //    "ListviewTitleFontWeight":"Bold",
            //    "ListviewTitleFontColor":"#000000",
            //    "TableHeaderFontColor":"#000000",
            //    "TableHeaderFontFamily":"Open Sans",
            //    "TableHeaderFontSize":"14px",
            //    "TableHeaderBackgroundColor":"#ffffff",
               "SearchBar":"true",
               "MobileVisible": "true", 
               "TabsVisible": "true",
               "updateFormState": false
            },

               
    'listview' : { "BorderWidth":"", "CombinedFontWeight":"Bold", "CombinedHeaderFontWeight":"Bold",
    "CustomId":"", "DuplicateRow":"true", "Enable":"true", 
    "ControlStyle":"",
                "FontFamily":"", 
                "FontStyle":"", 
                "FontWeight":"400", 
                "TableScrollRadio": "defaultGridScroll",
                "Grouping":"1", 
                "HeaderBackColor":"ffffff", 
                "HeaderFontFamily":"", 
                "HeaderFontSize":"", 
                'Height':"300",
                "AllowDownload" : "true",
                "AllowUpload" : "false",
                "GridTileViewType" : "vertical",
                "GridTileView" : "false",
                "HideAdd":"false",
                // "ShowOverlayBatchsButtons": "true", 
                "AllowDuplicatingRow": "true", 
                "ShowCheckbox": "true",
                 "HideDelete":"false",
                "HideMoreOptions":"false",
                "additionmethods": "Through Popup",
                "HidePrevNext":"N", "ListBtnAlignment":"0", "MergeSection":"1", "Searching":"true", "ShowCheckboxColumn":"false", "Sorting":"true", "Summary":"",
                "Visible":"true","showDataAdditonSection":"Through Popup", "isAdvancedListview":"false", "multiSelect":"true", "timeZone":"1","widthType" : "percentage", "ThemeLayout" : "box" ,
                // "ListviewTitleFontFamily":"Open Sans",
                // "ListviewTitleFontSize":"14px",
                // "ListviewTitleFontWeight":"Bold",
                // "ListviewTitleFontColor":"#000000",
                // "ListviewColumnFontFamily" : "Open Sans",
                // "ListviewColumnFontSize" : "14px",
                // "ListviewColumnBackgroundColor" : "#ffffff",
                // "ListviewColumnFontColor" : "#000000",
                "SearchBar":"true",
                "MobileVisible": "true", 
                "TabsVisible": "true",
            },

    'advancelistview' : { "BorderWidth":"", "CombinedFontWeight":"Bold", "CombinedHeaderFontWeight":"Bold"," CustomId":"", "DuplicateRow":"true", "Enable":"true", 
    "ControlStyle":"",
                "FontFamily":"", "FontStyle":"", "FontWeight":"400", "Grouping":"1", 
                "HeaderBackColor":"ffffff",  
                "HeaderFontFamily":"", 
                "HeaderFontSize":"", 
                "TableScrollRadio": "defaultGridScroll",
                'Height':"300",
                "AllowDownload" : "true",
                "AllowUpload" : "false",
                "HideAdd":"false",
                "GridTileViewType" : "vertical",
                "GridTileView" : "false",
                // "ShowOverlayBatchsButtons": "true", 
                 "HideDelete":"false",
                "HideMoreOptions":"false",
                "HidePrevNext":"N", "ListBtnAlignment":"0", "MergeSection":"1", "Searching":"true", "ShowCheckboxColumn":"false", "Sorting":"true", "Summary":"",
                "Visible":"true",
                "ShowCheckbox":"true",
                "GridModalType": "modal",
                "isAdvancedListview":"true", "multiSelect":"true", "timeZone":"1","widthType" : "percentage" , "ThemeLayout" : "box",
                // "ListviewTitleFontFamily":"Open Sans",
                // "ListviewTitleFontSize":"14px",
                // "ListviewTitleFontWeight":"Bold",
                // "ListviewTitleFontColor":"#000000",
                // "ListviewColumnFontFamily" : "Open Sans",
                // "ListviewColumnFontSize" : "14px",
                // "ListviewColumnBackgroundColor" : "#ffffff",
                // "ListviewColumnFontColor" : "#000000",
                "SearchBar":"true",
                "MobileVisible": "true", 
                "TabsVisible": "true",
                },
     
    'tableColumn' : {"AllowAlphabets":"true", "AllowDuplicate":"true", "AllowNull":"true", "AllowNumbers":"true", "AllowSpaces":"true"," AllowSpecialchars":"true", "AutoIncrement":"false", 
                "CellBackColor":"FFF", 
               'CellFontSize':"4", "CharLimit":"", "CharVisisbleOnOption":"", "ColumnMasking":"nomasking", "ColumnMethod":"", "ColumnTooltip":"", "DateMasking":"1", 
                "DigitGrouping":"", "EnableSearching":"true", 'EnableSorting':"true", 
                "ColumnHeaderColor":"#000000", 
                "HeaderFontSize":"4", 
                "ImageName":"", "IsIOID":"N",
                "LabelAlignment":"-1", 'MasterQuery':"", "MaxLength":"",'Pattern':"", "PatternMasking":"nomasking", "Precision":"", "ShowTotal":"false", "TableImageBtnURL":"", 
                 "TotalFontSize":"4", "AddRowButtonLabel":"true",
                 "columnMappedField":"2", "ColumnName":"Column", "ColumnType":"textbox", "complexFieldName":"", "complexFieldType":"Text", 
                'labelCaption':"", "labelMethodStyle":"2", "mappedControlField":"", "visibility":"true","DisplayLabelValue" : "Display Label",
                "MobileVisible": "true", 
                "TabsVisible": "true",
    },
    tableColumn1: {
        "ColumnName": "Column",
        "VisibleOnTable": "true",
        "ShowHeaderLabel": "true",
        // "ShowCellData": "true",
        "ShowTotal": "false",
        "SortingType": "false",
        "ShowToolTipAsInfoIcon":"false",
        "EnableSearch": "true",
        "AllowDuplicate": "true",
        "AssociatedField": "",
        "ColumnWidth": "10%",
        "ColumnType": "textbox",
        "ColumnTooltip": "",
        "MaskingPattern": "",
        "SaveEncrypted": "",
        "ShowDecrypted": "",
        "AllowAlphabets": "true",
        "AllowNull": "true",
        "AllowNumbers": "true",
        "AllowSpaces": "true",
        "AllowSpecialChars": "true",
        "columnCharacterSet": "",
        "columnMinValue": "",
        "columnMaxValue": "",
        "columnMaxLength": "",
        "column,CustomPattern": "",
        "ColumnHeaderFontWeight": "",
        "ColumnHeaderColor": "",
        "ColumnHeaderAlignment": "",
        "ColumnValuesFontWeight": "",
        "ColumnValuesColor": "",
        "MasterQuery": "", 
        "ColumnValuesAlignment": "",
        "DisplayLabelValue": "Display Label",
        "AddRowButtonLabel": "true",
        "isModify": "false",
        "ColumnMasking": "",
        "DateSeperator": "",
        "MobileVisible": "true",
        "TabsVisible": "true",
        "ManualInput": "true",
      },
    advancelistviewPopup: {
        "Header": "true",
        // "AdvListviewPopupWidth": "80%",
        // "AdvListviewPopupHeight": "80%",
        "ShowFooter": "true",
        "ShowSaveChanges": "true",
        "ShowOverlayBatchsButtons": "true", 
        "AllowDuplicatingRow": "true", 
        "ShowFooterWhenDisabled": "true",
        "AdvListviewBackgroundColor" : "#fff",
        "AdvListviewFooterBackgroundColor": "#fff", 
        "AdvListviewHeaderBackgroundColor": "#fff",
        "AdvListviewHeaderFontFamily": "Open Sans",
        "AdvListviewHeaderFontSize": "16px",
        "AdvListviewHeaderFontWeight": "SemiBold",
        "AdvListviewHeaderFontColor": "#606060",
        "PrimaryButton_FontFamily": "Open Sans",
        "PrimaryButton_FontSize": "12px",
        "PrimaryButton_FontWeight": "regular",
        "PrimaryButton_FontColor": "#fff",
        "PrimaryButton_BackgroundColor": "#0072c6",
        "PrimaryButton_BorderColor": "#0072c6",
        "PrimaryButton_BorderWidth": "1px",
        "PrimaryButton_BorderRadius": "2px",
        "SecondaryButton_FontFamily": "Open Sans",
        "SecondaryButton_FontSize": "12px",
        "SecondaryButton_FontWeight": "regular",
        "SecondaryButton_FontColor": "#0072c6",
        "SecondaryButton_BackgroundColor": "#fff",
        "SecondaryButton_BorderColor": "#0072c6",
        "SecondaryButton_BorderWidth": "1px",
        "SecondaryButton_BorderRadius": "2px",
        "SaveAndCloseLabel": "Save & Close",
        "SaveChangesLabel": "Save Changes",
        "SaveAndContinueLabel": "Save & Continue",
        "CloseLabel": "Close",
        "NextButtonLabel": "Next",
        "PreviousButtonLabel": "Previous",
        "DuplicateRowLabel": "Duplicate Row",
    },
    "listbox":{

        // "BackColor":"#fff",
        // "BorderColor":"#C4C4C4",
        // "BorderWidth":"1px",
        // "BorderRadius":"1px",
        
        "CharVisibleOnOption":"",
        "CombinedFontWeight":"Bold",
        "ComboType":"dropDown",
        // "ControlStyle":"style1",
        "CustomId":"",
        "Enable":"true",
        "Labels":"14",
        "Label": "",
        // "FontColor":"#000000",
        // "FontFamily":"Open Sans",
        // "FontSize":"12px",
        // "FontStyle":"",
        // "FontWeight":"300",
        "Grouping":"1",
        //"EnableMandatoryOnDisable": "false",
        // "LabelBackgoundColor":"#ffffff",
        // "LabelFontColor":"#000000",
        // "LabelFontFamily":"Open Sans",
        // "LabelFontSize":"12px",
        // "LabelFontWeight":"400",
        // "LabelInputAlignment":"-1",
        // "LabelInputRatio":"",
        "DefaultSelect": "",
        "ListSize":"",
        "Mandatory":"false",
        "MergeSection":"1",
        "ReadOnly":"false",
        "ReadOnlyStyle":"N", 
        "SortingOrder":"0",
        "Summary":"",
        "ToolTip":"", 
        ValidationMessage,
        "Visible":"true",
        "validateMandatoryDisable":"N",
        //added
        "showIcon":"",
        "addOptionsMethod":"manually",
        "DummyData":"",
        "MobileVisible": "true", 
        "TabsVisible": "true",
        },
        
        "combo":{
            // "BackColor":"#fff",
            // "BorderColor":"#c4c4c4",
            // "BorderWidth":"1px",
            // "BorderRadius":"1px",
            "Labels":"14",
            "CharVisibleOnOption":"",
            "CombinedFontWeight":"Normal",
            "ComboType":"dropDown",
            // "ControlStyle":"Style1",
            "CustomId":"",
            "Enable":"true",
        
            // "FontColor":"#000000",
            // "FontFamily":"Open Sans",
            // "FontSize":"12px",
            // "FontStyle":"",
            // "FontWeight":"300",
            "Grouping":"1", 
            //"LabelBackgoundColor":"#ffffff",
            // "LabelFontColor":"#000000",
            // "LabelFontFamily":"Open Sans",
            // "LabelFontSize":"12px",
            //"LabelFontWeight":"400",
            // "LabelInputAlignment":"-1",
            // "LabelInputRatio":"",
            "DefaultSelect": "",
            "DefaultSelect1": "Select",
            "DefaultSorting":"none",
            "ListSize":"",
            "Mandatory":"false",
            "MergeSection":"1",
            "ReadOnly":"false",
            "ReadOnlyStyle":"N", 
            "SortingOrder":"0",
            "Summary":"",
            "ToolTip":"", 
            ValidationMessage,
            "Visible":"true",
            "validateMandatoryDisable":"N",
            //added
            "LabelRatio":"",
            "showIcon":"",
            "addOptionsMethod":"manually",
            "DummyData":"",
            "MobileVisible": "true", 
	    	"TabsVisible": "true",
            },
        "radio":{
            "CombinedFontWeight": "Bold",
            "CustomId": "",
            "Summary": "",
            "ReadOnlyStyle": "N",
            "MergeSection": "1",
            "Grouping": "1",
            // "BorderColor": "dfe3e9",
            "Enable": "true",
            // "FontFamily": "Open Sans",
            "BackColor": "",
            // "FontColor": "",
            // "FontSize": "12px",
            // "FontWeight": "400",
            // "FontStyle": "#000",
            // "ControlStyle" : "Style2",
            "validateMandatoryDisable": "N",
            "ToolTip": "",
            "VerticalAlignment": "",
            // "LabelInputAlignment": "-1",
            // "LabelInputRatio": "",
            // "LabelFontColor": "#000",
            // "LabelBackgoundColor": "",
            // "LabelFontFamily": "Open Sans",
            // "LabelFontWeight": "400",
            // "LabelFontSize": "12px",
            "Allignment": "2",
            // "ControlStyle": "",
            // "BorderWidth": "",
            // "BorderRadius":"1px",
            "ReadOnly": "false",
            "Visible": "true",
            ValidationMessage,
            "Mandatory": "false",
            "FontColorSelectedState":"#FFFFFF",
            "BackgroundColorSelectedState":"#0072c6",
            "FontColorUnselectedState":"#606060",
            "BackgroundColorUnselectedState":"#FFFFFF",
            "MobileVisible": "true", 
            "TabsVisible": "true",
        },
        "image":{
            // "FontColor": "#000000",
            // "FontFamily": "Open Sans",
            // "FontSize": "12px",
            // "FontWeight": "100",
            "CustomId": "",
            "Label": "image1",
            "LabelInputAlignment": "topDown",
            "iconFile": "",
            "iconName": "",
            "BorderRadius": "2px",
            "BorderWidth": "",
            "BorderColor":"",
            "width":"140",
            "height":"100",
            "defaultWidth":"140",
            "defaultHeight":"100",
            "Visible":"true",
            "resize":"dimension",
            "size":"60",
            "scale":"pixels",
            "imageAlignment":"left",
            "transform":"enlarge",
            "enlarge":"1",
            "uploadType":"file",
            "MobileVisible": "true", 
            "TabsVisible": "true",
        },
 
        'label':{
            "Visible":"true",
            "MobileVisible": "true", 
            "TabsVisible": "true",
            "CustomId": "",
            "SpacingTop": '32px',
            "SpacingBottom": '7px',
            // "TextAlignment":"left",
            //"FontFamily":"Open Sans",
            //"FontSize":"14px", 
            // "FontWeight":"normal",
            //"FontColor":"#000000",
            // "BackColor":"#FFFFFF"
        },
        'link':{
            "Visible":"true",
            "Man":"true",
            "Enable":"true",
            // "LinkAlignment":"Left",
            "CustomId": "",
            // "FontFamily":"Open Sans",
            // "FontSize":"14px",
            "OnClick":"URL",
            // "FontWeight":"normal",
            "SpacingTop": '31px',
            "SpacingBottom": '5px',
            // "FontColor":"#3D6CE9",
            // "BackColor":"",
            "MobileVisible": "true", 
            "TabsVisible": "true",
        },
        'toggle' : {
            "Visible":"true",
            "Enable":"true",
            "MobileVisible": "true", 
            ValidationMessage,
            "TabsVisible": "true",
        },
        'richtexteditor':{
            'MaxHeight':'350',
            "CustomControlId":"",
            "Enable":"true",
            "Visible":"true",
            "Mandatory":"false",
            "BorderColor":"#C4C4C4",
            "BackgroundColor":"#FFFFFF",
            "BorderWidth":"1px",
            "BorderRadius":"2px",
            // "FontFamily":"Open Sans",
            // "FontSize":"14px",
            "FontWeight":"600",
            "FontColor":"#606060",
            "SpacingLeft":"",
            "SpacingRight":"",
            "SpacingBottom":"",
            "ToolTip":"",
            "ControlDescription":"",
            ValidationMessage,
            "isRichTextEditor" : "true",
            "MobileVisible": "true", 
		    "TabsVisible": "true",
        },
        "wizard_h": {
            "ActiveBackgroundColor": "#0072c6"
            ,"ActiveFontColor": "#000000"
            ,"ActiveFontWeight": "600"
            ,"ActiveStepCountColor": "#ffffff"
            ,"BorderColor": "#C4C4C4"
            ,"BorderRadius": "1px"
            ,"BorderWidth": "1px"
            ,"Enable": "true"
            ,"FontFamily": "Open Sans"
            ,"FontSize": "14px"
            ,"SubStepFontSize": "12px"
            ,"InactiveBackgroundColor": "#D3D3D3"
            ,"InactiveBorderColor": "#0072C6"
            ,"InactiveFontColor": "#606060"
            ,"InactiveFontWeight": "600"
            ,"InactiveStepCountColor": "#606060"
            ,"MobileVisible": "true"
            ,"ReadOnlyStyle": "false"
            ,"TabsVisible": "true"
            ,"Visible": "true"
            ,"alignment": "horizontal"
            ,"backgroundColor": "#F8F8F8"
            ,"fixedFooter": "false"
            ,"layout": "style1"
            ,"navigationMethod": "viaBoth"
            ,"showBorder": "true"
            ,"showIcons": "true"
            ,"showSubsteps": "true"
            ,"userDefinedId": "",
            "footerstyle":"standard1",
        },
        "wizard_v": {
            "ActiveBackgroundColor": "#0072c6"
            ,"ActiveFontColor": "#000000"
            ,"ActiveFontWeight": "600"
            ,"ActiveStepCountColor": "#ffffff"
            ,"ActiveFontWeight1":"normal"
            ,"ActiveFontStyle": "normal"
            ,"BorderColor": "#C4C4C4"
            ,"BorderRadius": "1px"
            ,"BorderWidth": "1px"
            ,"Enable": "true"
            ,"FontFamily": "Open Sans"
            ,"FontSize": "14px"
            ,"SubStepFontSize": "12px"
            ,"InactiveBackgroundColor": "#D3D3D3"
            // ,"InactiveBorderColor": "#0072C6"
            ,"InactiveFontColor": "#606060"
            ,"InactiveFontWeight": "600"
            ,"InactiveFontStyle": "normal"
            ,"InactiveStepCountColor": "#606060"
            ,"InactiveFontWeight1":"normal"
            ,"MobileVisible": "true"
            ,"ReadOnlyStyle": "false"
            ,"TabsVisible": "true"
            ,"Visible": "true"
            ,"alignment": "horizontal"
            ,"backgroundColor": "#F8F8F8"
            ,"fixedFooter": "false"
            ,"layout": "style1"
            ,"navigationMethod": "viaBoth"
            ,"showBorder": "true"
            ,"showIcons": "true"
            ,"showSubsteps": "true"
            ,"userDefinedId": "",
            "footerstyle":"standard1",
        },
        "sidenavigation": {
            "ActiveStepCountColor":"",
            "ActiveStepBackgroundColor":"#0072c6",
            "InActiveStepBackgroundColor":"#fff",
            "ActiveBackgroundColor": "",
            "ActiveFontColor": "#0072c6",
            "ActiveFontWeight": "Bold",
            "BorderColor": "#C4C4C4",
            "BorderRadius": "1px",
            "BorderWidth": "1px",
            "ActiveFontWeight1":"normal",
            "Enable": "true",
            "FontWeight":"normal",
            "FontStyle": "normal",
            "FontFamily": "Open Sans",
            "FontSize": "14px",
            "SubStepFontSize": "12px",
            "InactiveStepCountColor":"",
            // "InactiveBorderColor":"#0072c6",
            "InactiveBackgroundColor": "#F8F8F8",
            // "InactiveFontColor": "#0072c6",
            // "InactiveFontWeight": "Bold",
            "InactiveFontWeight1":"normal",
            "ReadOnlyStyle": "false",
            "Visible": "true",
            "alignment": "horizontal",
            "fixedFooter": "false",
            "layout": "style1",
            "navigationMethod": "viaBoth",
            "showBorder": "true",
            "showIcons": "true",
            "showSubsteps": "true",
            "userDefinedId": "",
            "backgroundColor":"#F6F6F6",
            "MobileVisible": "true", 
            "TabsVisible": "true",
            "footerstyle":"standard1",
            "activeSubTabFontColor":"#0072C6",
            "activeSubTabBorderWidth":"1",
            "activeSubTabBackgroundColor":"#0072C61a",
            "CloseIconBehavior":"compactView",
        },
        "Menu": {
            // "showIcons": "true",
            // "showSubsteps": "true",
            // "userDefinedId": "",
            // "showBorder":"true",

            // "layout": "style1",
            // "menuBackground":"",
            // "BorderColor": "#07314d",
            // "BorderWidth": "1px",
            // "BorderRadius": "1px",
            // "menuAlignment":"right",

            // "Visible": "true",
            // "Enable": "true",
            // "ReadOnlyStyle": "true",
            
            // "TabsVisible": "true",
            // "MobileVisible":"true",
            // "TabsVisible":"true",

            // "ActiveFontFamily": "Open Sans",
            // "ActiveFontSize": "14px",
            // "ActiveFontWeight": "Bold",
            // "ActiveFontColor": "#0072c6",
            // "ActiveBackgroundColor": "#0072c6",

            // "InActiveFontFamily": "Open Sans",
            // "InActiveFontSize": "14px",
            // "InActiveFontWeight": "Bold",
            // "InActiveFontColor": "#0072c6",
            // "InActiveBackgroundColor": "#0072c6",

            // "ButtonFontFamily": "Open Sans",
            // "ButtonFontSize": "14px",
            // "ButtonFontWeight": "Bold",
            // "ButtonFontColor": "#0072c6",
            // "ButtonBackgroundColor": "#0072c6",
            // "ButtonBorderWidth": "#0072c6",
            // "ButtonBorderRadius": "#0072c6",

            // "SpacingLeft":"5px",
            // "SpacingRight":"5px",
            // "SpacingTop":"5px",
            // "SpacingBottom":"5px"

                 "menuAlignment":"left",
                  "ButtonFontColor":"#fff",
                  "SpacingBottom":"",
                  "ActiveFontStyle":"normal",
                  "menuBackground":"",
                  "BorderColor":"#C6C9CF",
                  "BorderRadius":"1px",
                  "MobileVisible":"true",
                  "SpacingRight":"",
                  "BorderWidth":"1px",
                  "ButtonFontWeight":300,
                  "showIcons":"true",
                  "ButtonBorderWidth":"1px",
                  "ActiveFontFamily":"Open Sans",
                  "ActiveBackgroundColor":"#0072C6",
                  "Visible":"true",
                  "showSubsteps":"true",
                  "Enable":"true",
                  "ButtonFontFamily":"Open Sans",
                  "InActiveFontStyle":"normal",
                  "InActiveFontSize":"12px",
                  "InActiveBackgroundColor":"#fff",
                  "ButtonBorderRadius":"1px",
                  "ActiveFontWeight":400,
                  "ReadOnlyStyle":"false",
                  "showBorder":"true",
                  "InActiveFontWeight":400,
                  "layout":"style1",
                  "ActiveFontSize":"12px",
                  "userDefinedId":"",
                  "SpacingTop":"",
                  "TabsVisible":"true",
                  "ButtonFontSize":"12px",
                  "SpacingLeft":"",
                  "ButtonBackgroundColor":"#0072c6",
                  "InActiveFontFamily":"Open Sans",
                  "ActiveFontColor":"#fff",
                  "InActiveFontColor":"#606060"

        },
        "imagecarousel" : {
            "Visible" : "true",
            "CustomId": "",
            "AllowAutoScroll" : "true",
            "AutoplaySpeed" : '4000',
            'ImageCarouselHeight':'200',
            'Speed':'400','ImageCarouselWidth': '',
            "MobileVisible": "true", 
            "TabsVisible": "true",
            "imageList": [],
        },
        "doclist":{
            "DocTypeStyle":"Style1",
            // "FontColor":"#0072C6",
            ValidationMessage,
            "Visible":"true",
            "Enable":"true",
            // "BackgroundColor": "#FFFFFF",
            // "CornerRadius": "2px",
            "MobileVisible": "true", 
            "TabsVisible": "true",
            "UploadOption": "3",
            "BulkUploadButton": "true",
            "DocumentButtonBulkBackgroundColor": "#0072c6",
            "DocumentButtonBulkFontColor":"#FFFFFF",            
            // "FontStyle": "Normal",
            // "DocumentTypeLabelFontColor": "#000000",
            // "DocumentTypeLabelFontFamily": "Open Sans",
            // "DocumentTypeLabelFontWeight": "Normal",
            // "DocumentTypeLabelFontSize": "14px",

        },
        "documentType" : {
            "DocumentName": "Document 1", 
            "DockId":"",
            "Mandatory": false,
            "style": {},
            "DocTypeIcon":"",
            "SupportedDocumentsinDocType":[],
            "AllowedFileTypes":[],
            "AllowedFileExtensions":"",
            "DocTypeDescription":"",
            "MaxSizeOfDocType" : "KB",
            "MaxSizeOfDoc":"",
            "DimensionsOfImage":"",
            "AllowMultipleUploads":true,
            "allow_comment":true,
            "mandatory_comments": false,
            "MobileVisible": "true", 
            "TabsVisible": "true",
        },
        "page" : {
            "width" : "100%",
            "height" : "100%"
        },
        "defaultNewTheme" : {
            'BasicTheme': {'colorPallete' : [
                            {'colorName': 'Black', 'colorCode' : '#222222' , 'backgroundColor' : '#222222  ', borderRadius : '2px 0px 0px 2px'},
                            {'colorName': 'Dark Grey', 'colorCode' : '#4D4D4D','backgroundColor' : '#4D4D4D  '},
                            {'colorName': 'Light Grey', 'colorCode' : '#E0E0E0', 'backgroundColor' : '#E0E0E0  '},
                            {'colorName': 'White', 'colorCode' : '#FFFFFF', 'backgroundColor' : '#FFFFFF  '},
                            {'colorName': 'Tint 2 of Primary', 'colorCode' : '#685AC014', 'backgroundColor' : '#685AC014  '},
                            {'colorName': 'Tint 1 of Primary', 'colorCode' : '#685AC029', 'backgroundColor' : '#685AC029  '},
                            {'colorName': 'Secondary', 'colorCode' : '#AE2BC6', 'backgroundColor' : '#AE2BC6  '},
                            {'colorName': 'Primary', 'colorCode' : '#685AC0', 'backgroundColor' : '#685AC0  ', borderRadius : '0px 2px 2px 0px'}
                        ],
                        'PrimaryColor' : '#685AC0'
            }
        },
        "report" : {
            "Visible":"true",
            // "visible":"true",
            "Height":"150px",
            "reportName":"",
            "MobileVisible": "true", 
            "TabsVisible": "true",
            "height":"294"
        },
}

export {ThemeJSON} ;